module.exports = __webpack_public_path__ + "static/media/apotek-hjartat.f0f6cc67.svg";